import { Role } from "./ProtectedRoute";

export const ROUTE_PERMISSIONS: Record<string, Role[]> = {
  dashboard: ['admin', 'hr', 'employee'],

  admin: ['admin', 'hr'],
  employees: ['admin', 'hr'],
  payroll: ['admin', 'hr'],
  slackStatus: ['admin', 'hr'],
  onlineUsers: ['admin', 'hr'],
  regularizeAttendance: ['admin', 'hr'],

  attendanceList: ['admin', 'hr'],
  monthlyView: ['admin', 'hr'],
  viewAttendance: ['admin', 'hr'],

  tasksAll: ['admin', 'hr', 'employee'],
  teamTasks: ['admin', 'hr'],

  profile: ['admin', 'hr', 'employee'],
  leaveManagement: ['admin', 'hr', 'employee'],
  occasions: ['admin', 'hr', 'employee'],
  companyDocs: ['admin', 'hr', 'employee'],
  markAttendance: ['admin', 'hr', 'employee'],

  authOnly: ['admin', 'hr', 'employee'],
};